// JSX port of the companion footer + footer-enrollment line.
import React from 'react';
import { Icon } from './icons';

export default function Footer({ carePeriod }) {
  let enrollment = '';
  if (carePeriod?.care_period_start) {
    const d = new Date(carePeriod.care_period_start);
    if (Number.isFinite(d.getTime())) {
      enrollment = `This program — Enrolled ${d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' })}`;
    }
  }
  return (
    <footer className="acc-footer fade-up">
      <p className="acc-footer__text">The care team monitors this data daily.<br />The patient is never alone in this journey.</p>
      {enrollment && <p className="acc-footer__text" style={{ marginTop: 8 }}>{enrollment}</p>}
      <div className="acc-footer__logo"><Icon name="withings" size={32} /></div>
    </footer>
  );
}
